import { FC } from "react";

interface LevelUpProps {
    level: number;
}

export const LevelUp: FC<LevelUpProps> = ({ level }) => {
    return (
        <div className="relative w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-4xl">
            <div>Level { level }</div>
        </div>
    );
}